import { Decodable } from './_decodable';

class StockMovementItem extends Decodable {
    id?: number;
    stockMovementId?: number;
    unitId?: number;
    productId?: number;
    name?: string;
    quantity: number = 1;
    ordem: number = 1;
    productCode?: string;
    productImage?: string;
    productDescription?: string;
    productCategoryName?: string;
    productUnit?: string;
    createdAt?: Date;
    updatedAt?: Date;

    protected _map = {
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
    };
}

export { StockMovementItem };
